var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @file 起止日期选择器
 * @author (zhanghao14)
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import classnames from 'classnames';
import moment from 'moment';
import _ from 'lodash-es';

import Calendar from './Calendar';
import PopperWrap from '../PopperWrap';

import './DatePicker.less';

var getDateString = function getDateString(props, state) {
    return state.startDate ? state.startDate.format(props.format) : '';
};

var RangeDatePicker = function (_Component) {
    _inherits(RangeDatePicker, _Component);

    function RangeDatePicker(props) {
        _classCallCheck(this, RangeDatePicker);

        var _this = _possibleConstructorReturn(this, (RangeDatePicker.__proto__ || Object.getPrototypeOf(RangeDatePicker)).call(this, props));

        _this.inputContainerOnClick = function () {
            if (_this.props.disabled) {
                return;
            }

            if (!_this.state.isShowPanel) {
                _this.setState({
                    isShowPanel: true,
                    startDate: _this.stateDateDrivedFromProps(_this.props).startDate,
                    endDate: _this.stateDateDrivedFromProps(_this.props).endDate
                });
            }
        };

        _this.bodyClick = function () {
            _this.setState({
                isShowPanel: false
            });
        };

        _this.onDateChange = function (position, value) {
            var arr = _this.props.value.slice(0);
            if (arr[0] && arr[1] || !arr[0] && !arr[1]) {
                arr = [];
                arr[position] = _this.momentToString(value);
            } else {
                // 给空项赋值
                if (!arr[0]) {
                    arr[0] = _this.momentToString(value);
                } else if (!arr[1]) {
                    arr[1] = _this.momentToString(value);
                }
                // 排序
                if (arr[0] > arr[1]) {
                    var temp = arr[0];
                    arr[0] = arr[1];
                    arr[1] = temp;
                }
                // 选择完毕自动收起
                _this.setState({ isShowPanel: false });
            }

            var _this$props = _this.props,
                getValue = _this$props.getValue,
                name = _this$props.name;

            getValue && _this.props.getValue({
                name: name,
                value: arr
            });
        };

        _this.betweenSelected = function (date) {
            var _this$props$value = _slicedToArray(_this.props.value, 2),
                start = _this$props$value[0],
                end = _this$props$value[1];

            var format = _this.props.format;
            var dateStr = date.format(format);
            var hoverDateString = _this.state.hoverDate && _this.state.hoverDate.format(format);
            if (start && end) {
                // 选择后中间样式
                if (dateStr < end && dateStr > start) {
                    return true;
                }
            } else if (start) {
                // hover时中间样式
                if (hoverDateString && (dateStr < start && dateStr >= hoverDateString || dateStr > start && dateStr <= hoverDateString)) {
                    return true;
                }
            } else if (end) {
                // hover时中间样式
                if (hoverDateString && (dateStr < end && dateStr >= hoverDateString || dateStr > end && dateStr <= hoverDateString)) {
                    return true;
                }
            }
            return false;
        };

        _this.onMouseEnterDate = function (date) {
            _this.setState({ hoverDate: date });
        };

        _this.onMouseLeaveDate = function () {
            _this.setState({
                hoverDate: null
            });
        };

        _this.onStartChange = _this.onStartChange.bind(_this);
        _this.onEndChange = _this.onEndChange.bind(_this);
        _this.onCloseByWindow = _this.onCloseByWindow.bind(_this);
        _this.onIconClick = _this.onIconClick.bind(_this);
        _this.onMouseEnter = _this.onMouseEnter.bind(_this);
        _this.onMouseLeave = _this.onMouseLeave.bind(_this);

        _this.state = {
            isShowPanel: false,
            startDate: _this.stateDateDrivedFromProps(_this.props).startDate,
            endDate: _this.stateDateDrivedFromProps(_this.props).endDate,
            hoverDate: null
        };

        _this.FORM_NEED_VALIDATE = 0;
        _this.FORM_NO_NEED_VALIDATE = 1;

        _this.formCallback(_this.props.value, _this.FORM_NO_NEED_VALIDATE);
        return _this;
    }

    _createClass(RangeDatePicker, [{
        key: 'formCallback',
        value: function formCallback(data, type, isDelete) {
            var _props = this.props,
                formFlag = _props.formFlag,
                increment = _props.increment,
                name = _props.name,
                onHandleChange = _props.onHandleChange;


            if (onHandleChange && formFlag && _.isFunction(onHandleChange)) {
                onHandleChange({
                    name: name,
                    value: data
                }, this, type, increment, isDelete);
            }
        }
    }, {
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(nextProps) {
            if (!_.isEqual(this.props.value, nextProps.value)) {
                this.formCallback(nextProps.value, this.FORM_NEED_VALIDATE);
                // 根据是否是同一个月，或者单一值来判断月份展示情况
                this.setState({
                    startDate: this.stateDateDrivedFromProps(nextProps).startDate,
                    endDate: this.stateDateDrivedFromProps(nextProps).endDate
                });
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.formCallback(this.props.value, this.FORM_NO_NEED_VALIDATE, true);
        }
    }, {
        key: 'onStartChange',
        value: function onStartChange(value) {
            var obj = {};
            if (moment(value).year() === moment(this.state.endDate).year() && moment(value).month() === moment(this.state.endDate).month()) {
                obj = {
                    startDate: value,
                    endDate: value.clone().add(1, 'month')
                };
            } else {
                obj = {
                    startDate: value
                };
            }
            this.setState(obj);
        }
    }, {
        key: 'onEndChange',
        value: function onEndChange(value) {
            var obj = {};
            if (moment(value).year() === moment(this.state.startDate).year() && moment(value).month() === moment(this.state.startDate).month()) {
                obj = {
                    startDate: value.clone().add(-1, 'month'),
                    endDate: value
                };
            } else {
                obj = {
                    endDate: value
                };
            }
            this.setState(obj);
        }
    }, {
        key: 'onCloseByWindow',
        value: function onCloseByWindow() {
            this.setState({
                isShowPanel: false
            });
        }
    }, {
        key: 'onIconClick',
        value: function onIconClick(e) {
            if (this.props.disabled || !this.props.clearIcon) {
                return;
            }
            e.stopPropagation();
            if (getDateString(this.props, this.state)) {
                this.setState({
                    startDate: null,
                    endDate: null
                });
            }
            var _props2 = this.props,
                getValue = _props2.getValue,
                name = _props2.name;

            getValue && this.props.getValue({
                name: name,
                value: []
            });
        }
    }, {
        key: 'onMouseEnter',
        value: function onMouseEnter() {
            if (this.props.disabled || !this.props.clearIcon) {
                return;
            }

            var value = this.props.value[0] || this.props.value[1];
            value && this.setState({
                isShowClearIcon: true
            });
        }
    }, {
        key: 'onMouseLeave',
        value: function onMouseLeave() {
            if (this.props.disabled || !this.props.clearIcon) {
                return;
            }

            this.setState({
                isShowClearIcon: false
            });
        }
    }, {
        key: 'momentToString',
        value: function momentToString(moment) {
            if (!moment) {
                return '';
            }
            return moment.format(this.props.format);
        }
    }, {
        key: 'stringToMoment',
        value: function stringToMoment(string) {
            if (!string) {
                return null;
            }
            return moment(string, this.props.format);
        }
    }, {
        key: 'isPropsValueSameMonth',
        value: function isPropsValueSameMonth(props) {
            var _props$value = _slicedToArray(props.value, 2),
                date1 = _props$value[0],
                date2 = _props$value[1];

            if (!date1 || !date2) {
                return false;
            }
            return moment(date1).year() === moment(date2).year() && moment(date1).month() === moment(date2).month();
        }
    }, {
        key: 'calendarShowHeaderButton',
        value: function calendarShowHeaderButton() {
            var obj = {};
            var _state = this.state,
                startDate = _state.startDate,
                endDate = _state.endDate;

            if (moment(startDate).year() === moment(endDate).year() && moment(startDate).clone().add(1, 'month').month() === moment(endDate).month()) {
                obj.start = [true, true, false, false];
                obj.end = [false, false, true, true];
            } else if (moment(startDate).year() === moment(endDate).year()) {
                obj.start = [true, true, true, false];
                obj.end = [false, true, true, true];
            } else {
                obj.start = [true, true, true, true];
                obj.end = [true, true, true, true];
            }
            return obj;
        }
    }, {
        key: 'stateDateDrivedFromProps',
        value: function stateDateDrivedFromProps(props) {
            var now = moment();
            var next = now.clone().add(1, 'month');
            return {
                startDate: !props.value[0] && props.value[1] ? this.stringToMoment(props.value[1]).clone().add(-1, 'month') : this.stringToMoment(props.value[0]) || now,
                endDate: this.isPropsValueSameMonth(props) || props.value[0] && !props.value[1] ? this.stringToMoment(props.value[0]).clone().add(1, 'month') : this.stringToMoment(props.value[1]) || next
            };
        }
    }, {
        key: 'render',
        value: function render() {
            var _classnames,
                _classnames2,
                _classnames3,
                _this2 = this,
                _classnames4;

            var _props3 = this.props,
                placeHolder = _props3.placeHolder,
                zIndex = _props3.zIndex,
                preventOverflowEnabled = _props3.preventOverflowEnabled,
                popupOnBody = _props3.popupOnBody,
                classPrefix = _props3.classPrefix,
                placement = _props3.placement,
                format = _props3.format,
                disabled = _props3.disabled,
                width = _props3.width,
                className = _props3.className,
                disableDate = _props3.disableDate,
                validate = _props3.validate,
                tips = _props3.tips,
                label = _props3.label,
                noWarning = _props3.noWarning,
                responsive = _props3.responsive;


            var prefixCls = classPrefix + '-range-date-picker';
            var divClass = classnames((_classnames = {}, _defineProperty(_classnames, prefixCls, true), _defineProperty(_classnames, className, !!className), _defineProperty(_classnames, 'margin-bottom-24', !noWarning), _defineProperty(_classnames, 'responsive', responsive), _classnames));
            var inputClass = classnames((_classnames2 = {}, _defineProperty(_classnames2, prefixCls + '-input', true), _defineProperty(_classnames2, classPrefix + '-input', true), _classnames2));
            var iconClass = classnames((_classnames3 = {}, _defineProperty(_classnames3, prefixCls + '-icon', true), _defineProperty(_classnames3, prefixCls + '-icon-hover', this.state.isShowClearIcon), _classnames3));
            var startInputProps = {
                type: 'text',
                value: this.props.value[0] || '',
                placeholder: placeHolder[0],
                className: inputClass,
                readOnly: true,
                onKeyDown: this.onKeyDown
            };
            var endInputProps = {
                type: 'text',
                value: this.props.value[1] || '',
                placeholder: placeHolder[1],
                className: inputClass,
                readOnly: true,
                onKeyDown: this.onKeyDown
            };
            var iconProps = {
                className: iconClass,
                onClick: this.onIconClick,
                onMouseEnter: this.onMouseEnter,
                onMouseLeave: this.onMouseLeave
            };
            var startCalendarProps = {
                prefixCls: classPrefix + '-date-picker',
                className: prefixCls + '-calendar',
                selectValue: [this.props.value[0] && moment(this.props.value[0]) || null, this.props.value[1] && moment(this.props.value[1]) || null],
                value: this.state.startDate,
                onDateChange: this.onDateChange.bind(this, 0),
                onChange: this.onStartChange,
                rangeDate: this.props.value,
                showYearAndMonthButton: this.calendarShowHeaderButton().start,
                betweenSelected: this.betweenSelected,
                format: format,
                onMouseEnterDate: this.onMouseEnterDate,
                onMouseLeaveDate: this.onMouseLeaveDate,
                disableDate: disableDate
            };
            var endCalendarProps = {
                prefixCls: classPrefix + '-date-picker',
                className: prefixCls + '-calendar',
                selectValue: [this.props.value[0] && moment(this.props.value[0]), this.props.value[1] && moment(this.props.value[1])],
                value: this.state.endDate,
                onDateChange: this.onDateChange.bind(this, 1),
                onChange: this.onEndChange,
                rangeDate: this.props.value,
                showYearAndMonthButton: this.calendarShowHeaderButton().end,
                betweenSelected: this.betweenSelected,
                format: format,
                onMouseEnterDate: this.onMouseEnterDate,
                onMouseLeaveDate: this.onMouseLeaveDate,
                disableDate: disableDate
            };
            return React.createElement(
                'div',
                { className: divClass, ref: function ref(el) {
                        return _this2.rdpContainer = el;
                    } },
                label ? React.createElement(
                    'span',
                    { className: classPrefix + '-form-label' },
                    label
                ) : null,
                React.createElement(PopperWrap, {
                    containerNode: React.createElement(
                        'span',
                        {
                            className: classnames((_classnames4 = {}, _defineProperty(_classnames4, classPrefix + '-range-date-picker-input-container', true), _defineProperty(_classnames4, 'disabled', disabled), _defineProperty(_classnames4, 'focus', this.state.isShowPanel), _defineProperty(_classnames4, 'border-warning', validate && validate.ret !== 0), _classnames4)),
                            style: { width: width },
                            onClick: this.inputContainerOnClick
                        },
                        React.createElement('input', _extends({
                            ref: function ref(input) {
                                _this2.startInput = input;
                            }
                        }, startInputProps)),
                        React.createElement(
                            'span',
                            { className: classPrefix + '-range-date-picker-input-separator' },
                            ' \u81F3 '
                        ),
                        React.createElement('input', _extends({
                            ref: function ref(input) {
                                _this2.endInput = input;
                            }
                        }, endInputProps)),
                        React.createElement('div', iconProps),
                        !noWarning && validate && validate.message && React.createElement(
                            'div',
                            { className: classPrefix + '-form-warning' },
                            React.createElement('i', { className: classPrefix + '-form-error' }),
                            validate.message
                        )
                    ),
                    popupNode: React.createElement(
                        'div',
                        { className: classPrefix + '-range-date-picker-container' },
                        React.createElement(
                            'div',
                            { className: classPrefix + '-range-date-picker-left' },
                            React.createElement(Calendar, startCalendarProps)
                        ),
                        React.createElement(
                            'div',
                            { className: classPrefix + '-range-date-picker-right' },
                            React.createElement(Calendar, endCalendarProps)
                        )
                    ),
                    placement: placement,
                    isShowPopup: this.state.isShowPanel,
                    onBodyClick: this.bodyClick,
                    popupNodeZIndex: zIndex,
                    preventOverflowEnabled: preventOverflowEnabled,
                    popupOnBody: popupOnBody
                }),
                tips ? React.createElement(
                    'span',
                    { className: classPrefix + '-form-tips' },
                    tips
                ) : null
            );
        }
    }]);

    return RangeDatePicker;
}(Component);

export default RangeDatePicker;


RangeDatePicker.defaultProps = {
    // base
    skin: '',
    className: '',
    style: {},
    // self
    format: 'YYYY-MM-DD',
    value: [],
    classPrefix: 'spui2',
    placeHolder: ['开始日期', '结束日期'],
    placement: 'bottom-start',
    clearIcon: true,
    zIndex: 999
};

RangeDatePicker.propTypes = {
    skin: PropTypes.string,
    className: PropTypes.string,
    style: PropTypes.object,
    value: PropTypes.array,
    format: PropTypes.string,
    classPrefix: PropTypes.string,
    placeHolder: PropTypes.array,
    zIndex: PropTypes.number,
    preventOverflowEnabled: PropTypes.bool,
    popupOnBody: PropTypes.bool,
    placement: PropTypes.string,
    getValue: PropTypes.func,
    name: PropTypes.string,
    onHandleChange: PropTypes.func,
    increment: PropTypes.string,
    formFlag: PropTypes.bool,
    disabled: PropTypes.bool,
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    disableDate: PropTypes.func,
    clearIcon: PropTypes.bool,
    validate: PropTypes.object,
    tips: PropTypes.node,
    label: PropTypes.node,
    noWarning: PropTypes.bool,
    responsive: PropTypes.bool
};